import React, { useState, useEffect } from 'react'
import line from '../../../assets/rdLine.svg'
import threeLine from '../../../assets/rdph1.png'
import threeLine2 from '../../../assets/rdph2.png'
import svgScroll from 'svg-scroll'
import { svgPathProperties } from 'svg-path-properties'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
// import {DrawSVGPlugin} from 'gsap/dist/DrawSVGPlugin'
// import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin'
import { gsap } from 'gsap'

const RoadMap = () => {
  gsap.registerPlugin(ScrollTrigger)

  useEffect(() => {
    AOS.init()
    // gsap.fromTo("#rdLine", {
    //   drawSVG: 0
    // }, {
    //   drawSVG: "100%",
    //   ease: "none",
    //   scrollTrigger: {
    //     trigger: ".rdMp",
    //     // pin: true,
    //     scrub: 0.5,
    //     start: "top top",
    //     end: "max"
    //   }
    // })
  }, [])
  let ref = React.useRef()
  let path = document.getElementById('rdLine')
  let [pathLengths, setPathLength] = useState(0)
  const properties = new svgPathProperties(
    'M373.591 3C373.591 4.47276 374.785 5.66667 376.258 5.66667C377.731 5.66667 378.924 4.47276 378.924 3C378.924 1.52724 377.731 0.333333 376.258 0.333333C374.785 0.333333 373.591 1.52724 373.591 3ZM652.567 294.414L652.299 293.992L652.567 294.414ZM652.567 1072.51L652.29 1072.09L652.567 1072.51ZM373.091 1513C373.091 1514.47 374.285 1515.67 375.757 1515.67C377.23 1515.67 378.424 1514.47 378.424 1513C378.424 1511.53 377.23 1510.33 375.757 1510.33C374.285 1510.33 373.091 1511.53 373.091 1513ZM376.128 3.48275C463.849 27.1415 580.59 69.7616 651.525 121.536C687.009 147.436 710.908 175.539 714.128 204.604C717.341 233.607 699.975 263.816 652.299 293.992L652.834 294.837C700.632 264.584 718.398 234.067 715.122 204.494C711.853 174.984 687.641 146.66 652.114 120.729C581.026 68.8424 464.14 26.1843 376.388 2.51725L376.128 3.48275ZM652.299 293.992C592.674 331.731 515.957 364.4 436.205 394.54C396.332 409.609 355.708 424.043 316.089 438.161C276.472 452.278 237.858 466.08 202.015 479.882C130.35 507.479 69.6858 535.105 34.1967 565.309C16.4483 580.415 4.93953 596.212 1.54663 613.028C-1.85075 629.866 2.90864 647.623 17.4774 666.588L18.2704 665.979C3.8264 647.176 -0.798516 629.707 2.52688 613.226C5.85675 596.723 17.1778 581.107 34.8449 566.071C70.1868 535.992 130.696 508.418 202.375 480.816C238.204 467.018 276.806 453.221 316.425 439.103C356.041 424.985 396.675 410.548 436.559 395.475C516.321 365.332 593.118 332.633 652.834 294.837L652.299 293.992ZM17.4774 666.588C32.0526 685.562 57.3532 703.173 89.8476 719.839C122.353 736.51 162.109 752.262 205.646 767.495C292.695 797.953 395.008 826.388 484.736 855.946C529.618 870.73 571.369 885.801 606.539 901.559C641.718 917.32 670.274 933.752 688.795 951.245C707.31 968.732 715.725 987.203 710.843 1007.1C705.947 1027.05 687.648 1048.59 652.29 1072.09L652.844 1072.93C688.255 1049.38 706.825 1027.66 711.814 1007.33C716.817 986.952 708.133 968.134 689.482 950.518C670.836 932.908 642.157 916.421 606.948 900.646C571.732 884.867 529.943 869.784 485.049 854.996C395.226 825.407 293.043 797.016 205.976 766.551C162.456 751.324 122.75 735.59 90.304 718.949C57.8473 702.302 32.708 684.774 18.2704 665.979L17.4774 666.588ZM652.29 1072.09C443.039 1211.22 375.257 1367.81 375.257 1513H376.257C376.257 1368.19 443.831 1211.9 652.844 1072.93L652.29 1072.09Z',
  )
  const pathLength = properties.getTotalLength()

  // Offset the dashes so the it appears hidden entirely

  // useEffect(() => {
  //   ref.current.style.strokeDasharray = pathLengths + ' ' + pathLengths

  //   ref.current.style.strokeDashoffset = pathLengths
  //   ref.current.style.fill = 'none'
  //   setPathLength(ref.current.getTotalLength())
  //   // console.log(ref.current.getTotalLength())
  // }, [pathLengths])

  // window.addEventListener('scroll', function (e) {
  //   // What % down is it?
  //   var scrollPercentage =
  //     (document.documentElement.scrollTop + document.body.scrollTop) /
  //     (document.documentElement.scrollHeight -
  //       document.documentElement.clientHeight)

  //   // Length to offset the dashes
  //   var drawLength = pathLengths * scrollPercentage

  //   // Draw in reverse
  //   ref.current.style.strokeDashoffset = pathLengths - drawLength
  // })

  return (
    <div className="rdmContainer" id="Creators">
      <div className="rdmSctn">
        <div className="rdmCntnt">
          <div className="rdmHead csCenter">
            <p>
              Creators are the <br /> missing link for <span> web3 </span>{' '}
              <br /> mass adoption
            </p>
          </div>
          <div className="rdMp">
            {/* <img src={line} ref={ref} className="rdStLine" alt="line" /> */}
            <svg
              width="716"
              height="1516"
              viewBox="0 0 716 1516"
              className="rdStLine"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g style={{ mixBlendMode: 'color-dodge' }} opacity="0.84">
                <path
                  ref={ref}
                  id="rdLine"
                  d="M373.591 3C373.591 4.47276 374.785 5.66667 376.258 5.66667C377.731 5.66667 378.924 4.47276 378.924 3C378.924 1.52724 377.731 0.333333 376.258 0.333333C374.785 0.333333 373.591 1.52724 373.591 3ZM652.567 294.414L652.299 293.992L652.567 294.414ZM652.567 1072.51L652.29 1072.09L652.567 1072.51ZM373.091 1513C373.091 1514.47 374.285 1515.67 375.757 1515.67C377.23 1515.67 378.424 1514.47 378.424 1513C378.424 1511.53 377.23 1510.33 375.757 1510.33C374.285 1510.33 373.091 1511.53 373.091 1513ZM376.128 3.48275C463.849 27.1415 580.59 69.7616 651.525 121.536C687.009 147.436 710.908 175.539 714.128 204.604C717.341 233.607 699.975 263.816 652.299 293.992L652.834 294.837C700.632 264.584 718.398 234.067 715.122 204.494C711.853 174.984 687.641 146.66 652.114 120.729C581.026 68.8424 464.14 26.1843 376.388 2.51725L376.128 3.48275ZM652.299 293.992C592.674 331.731 515.957 364.4 436.205 394.54C396.332 409.609 355.708 424.043 316.089 438.161C276.472 452.278 237.858 466.08 202.015 479.882C130.35 507.479 69.6858 535.105 34.1967 565.309C16.4483 580.415 4.93953 596.212 1.54663 613.028C-1.85075 629.866 2.90864 647.623 17.4774 666.588L18.2704 665.979C3.8264 647.176 -0.798516 629.707 2.52688 613.226C5.85675 596.723 17.1778 581.107 34.8449 566.071C70.1868 535.992 130.696 508.418 202.375 480.816C238.204 467.018 276.806 453.221 316.425 439.103C356.041 424.985 396.675 410.548 436.559 395.475C516.321 365.332 593.118 332.633 652.834 294.837L652.299 293.992ZM17.4774 666.588C32.0526 685.562 57.3532 703.173 89.8476 719.839C122.353 736.51 162.109 752.262 205.646 767.495C292.695 797.953 395.008 826.388 484.736 855.946C529.618 870.73 571.369 885.801 606.539 901.559C641.718 917.32 670.274 933.752 688.795 951.245C707.31 968.732 715.725 987.203 710.843 1007.1C705.947 1027.05 687.648 1048.59 652.29 1072.09L652.844 1072.93C688.255 1049.38 706.825 1027.66 711.814 1007.33C716.817 986.952 708.133 968.134 689.482 950.518C670.836 932.908 642.157 916.421 606.948 900.646C571.732 884.867 529.943 869.784 485.049 854.996C395.226 825.407 293.043 797.016 205.976 766.551C162.456 751.324 122.75 735.59 90.304 718.949C57.8473 702.302 32.708 684.774 18.2704 665.979L17.4774 666.588ZM652.29 1072.09C443.039 1211.22 375.257 1367.81 375.257 1513H376.257C376.257 1368.19 443.831 1211.9 652.844 1072.93L652.29 1072.09Z"
                  fill="#ABFF29"
                  // stroke="#ABFF29"
                  // strokeWidth="1"
                />
              </g>
            </svg>

            <div className="rdShadGrn"></div>
            <div className="rdShadGrey"></div>
            <div className="rdMpBox">
              <div className="rdMpTxt">
                <img
                  src={threeLine}
                  data-aos="zoom-in"
                  data-aos-offset="200"
                  data-aos-duration="1000"
                  data-aos-easing="ease-in"
                  className="rdSmLine"
                  alt="lines"
                />
                <p>
                  Our entertainment industry forces creators into extractive
                  value chains, legal exploitation, and creative suppression. A
                  handful of corporations hold most IPs captive or locked away
                  in their vaults. The industry is playing a zero-sum game.
                </p>
              </div>
              <div className="rdMpTxt rdMpRtTxt">
                <img
                  src={threeLine2}
                  className="rdSmRtLine"
                  data-aos="zoom-in"
                  data-aos-offset="200"
                  data-aos-duration="1000"
                  data-aos-easing="ease-in"
                  alt="lines"
                />
                <img
                  src={threeLine}
                  data-aos="zoom-in"
                  data-aos-offset="200"
                  data-aos-duration="1000"
                  data-aos-easing="ease-in"
                  className="rdSmLine mbRdPh2Img"
                  alt="lines"
                />

                <p>
                  Meanwhile, web2 companies are pretending to unlock the
                  “Creator Economy” when in fact, they are devaluing creative
                  content to bootstrap a network effect and develop
                  monopoly-like leverage over audiences on a global scale.
                  Creators are trapped between the hammer and the anvil.
                </p>
              </div>
              <div className="rdMpTxt">
                <img
                  src={threeLine}
                  className="rdSmLine"
                  data-aos="zoom-in"
                  data-aos-offset="200"
                  data-aos-duration="1000"
                  data-aos-easing="ease-in"
                  alt="lines"
                />
                <p>
                  Web3 is an inflection point that can turn IP development into a positive
                  sum game and shed the gatekeeping paradigm. Artists deserve
                  control over their tools and unrestricted access to their
                  audience. That is how creators can create the experiences that
                  will onboard the next generation of users.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RoadMap
